import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import Chat from './Chat'
import { MetaTags } from 'react-meta-tags'
import SideComponent from './SideComponent'
import ManagementCreate from './components/ManagementCreate'
import ManagementHistory from './components/ManagementHistory'
import ChatContact from './components/ChatContact'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

export const Index = (props) => {
  const [managementOpen, setManagementOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [chatType, setChatType] = useState(null);
  const [managementUpdate, setManagementUpdate] = useState(null);
  const [contactsRefresh, setContactsRefresh] = useState(false);
  const [manualRefresh, setManualRefresh] = useState(0);
  const [isLead, setIsLead] = useState(false);
  const [campaignRefresh, setCampaignRefresh] = useState(false);
  const [leadId, setLeadId] = useState(null);
  const [leadData, setLeadData] = useState([]);
  const [negocios, setNegocios] = useState([]);
  const location = useLocation();
  const { selectedChatId, contactId, type,} = location.state || {};
 
  useEffect(() => {
    if (contactId) {
      setSelectedContact(contactId);
    }
    if (selectedChatId) {
      setSelectedPhoneNumber(selectedChatId);
    }
    if (type) {
      setChatType(type);
    }
  }, [contactId, selectedChatId, type]);

  const handleLeadData = (selected) => {
    setLeadData(selected);
  };

  const handleLead = (selected) => {
    setLeadOpen(selected);
    if (selected === true) {
      setManagementOpen(false);
      setHistoryOpen(false);
      setContactOpen(false);
    }
  };
  const handleRefresh = (refresh) =>{
    setManagementOpen(false)
    setSelectedPhoneNumber(null)
    setSelectedContact(null) 
    setManualRefresh(prev => prev + 1);  


  }
  const updateManagementOpen = (isOpen) => {
    setManagementOpen(isOpen);
    setHistoryOpen(false);
    setContactOpen(false);
  };
  const updateHistoryOpen = (isOpen) => {
    setHistoryOpen(isOpen);
    setContactOpen(false);
    setManagementOpen(false);
  };
  const updateContactOpen = (isOpen) => {
    setContactOpen(isOpen);
    setHistoryOpen(false);
    setManagementOpen(false);
  };
  const handlePhoneNumberSelect = (phoneNumber) => {
    setSelectedPhoneNumber(phoneNumber);
  };
  const handleContactId = (id) => {
    setSelectedContact(id);
  };
  const handleCampaignId = (id) => {
    setSelectedCampaign(id);
    setNegocios(id?.[0]?.negocios)
  };
  const handleChatType = (type) => {
    setChatType(type);
  };
  const handleManagementCreateSubmitStatus = (isSuccess) => {
    setManagementUpdate(isSuccess)
  }
  const handleIsLeadUpdate = (isLead) => {
    setIsLead(isLead)
  };
  const handleCampaignRefresh = (campaign) => {
    setCampaignRefresh(campaign)
  }
  const handleLeadIdUpdate = (leadId) => {
    setLeadId(leadId)
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cuidad Limpia | Whatsapp </title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col lg={4} style={{ display: managementOpen || historyOpen || contactOpen ? 'none'  : 'block' }}>
              <SideComponent
                onPhoneNumberSelect={handlePhoneNumberSelect}
                onContactId={handleContactId}
                onCampaignId={handleCampaignId}
                onLead= {handleLeadData}
                onChatType={handleChatType}
                managementUpdate={managementUpdate}
                contactsRefresh={contactsRefresh}
                campaignRefresh={campaignRefresh}
                updateLeadOpen={handleLead}
                setContactsRefresh ={()=> setContactsRefresh(false)}
                manualRefresh={manualRefresh}
              />
            </Col>

            <Col lg={managementOpen || historyOpen || contactOpen ? 7 : 8} 
              style={{ position: managementOpen || historyOpen || contactOpen ? 'absolute' : 'relative', 
                left: managementOpen || historyOpen || contactOpen  ? '7%' : 0, display: leadOpen ? 'none'  : 'block' }}>
              <Chat
                updateManagementOpen={updateManagementOpen}
                updateHistoryOpen={updateHistoryOpen}
                updateContactOpen={updateContactOpen}
                selectedContact={selectedContact}
                selectedPhoneNumber={selectedPhoneNumber}
                onCampaignId={handleCampaignId}
                chatType = {chatType}
                contactsRefresh={contactsRefresh}
                onIsLeadUpdate={handleIsLeadUpdate}
                campaignRefresh={handleCampaignRefresh}
                onLeadIdUpdate={handleLeadIdUpdate}
                setContactsRefresh ={()=> setContactsRefresh(false)}
                onContactId={handleContactId} //para cuando abren el chat desde contactos 
                refresh={handleRefresh}
              />
            </Col>
            {managementOpen && (
              <Col lg={4} style={{ position: 'absolute', right:'2%' }}>
                <ManagementCreate 
                updateManagementOpen={updateManagementOpen}
                selectedContact={selectedContact}
                selectedCampaign={selectedCampaign}
                isLead={isLead}
                leadId={leadId}
                leadData={leadData}
                negocios={negocios}
                onSubmitStatus={handleManagementCreateSubmitStatus}
                refresh={handleRefresh} />
              </Col>
            )}
             {historyOpen && (
              <Col lg={4} style={{ position: 'absolute', right:'2%' }}>
                <ManagementHistory updateHistoryOpen={updateHistoryOpen} />
              </Col>
            )}
              {contactOpen && (
              <Col lg={4} style={{ position: 'absolute', right:'2%' }}>
                <ChatContact 
                  updateContactOpen={updateContactOpen} 
                  selectedContact={selectedContact}
                  contactsRefresh={()=> setContactsRefresh(true)} />
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
